import { connect } from 'react-redux';
import compose from 'redux/lib/compose';
import { withInitAction } from '@mediamonks/react-redux-component-init';

import { COMPONENT } from 'common/src/app/data/entityTypes';
import { getComponent } from 'common/src/app/actions/resources/componentActions';
import { API_COMPONENT_ACCOUNT_LOGIN_BACKGROUND } from 'common/src/app/data/apiComponents';

import AccountLogin from './AccountLogin';

const mapStateToProps = state => ({
  background: state.entities[COMPONENT]?.[API_COMPONENT_ACCOUNT_LOGIN_BACKGROUND]?.image,
  isWebView: state.config.isWebView,
});

const addInitAction = withInitAction({
  prepared: ({}, dispatch) => dispatch(getComponent(API_COMPONENT_ACCOUNT_LOGIN_BACKGROUND)),
});

const connected = connect(mapStateToProps);

export default compose(addInitAction, connected)(AccountLogin);
